import React from "react";
import styles from "./formRow.module.scss";
const FormRow = ({ children }) => {
    return React.createElement("div", { className: styles.root }, children);
};
FormRow.displayName = "formRow";
export default FormRow;
//# sourceMappingURL=FormRow.js.map